import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingScreen = ({ isVisible }) => {
  return (
    <div 
      className={`fixed inset-0 bg-white dark:bg-gray-900 z-50 flex items-center justify-center
                  transition-all duration-500 ease-in-out ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
    >
      <div className={`flex items-center transition-transform duration-500 ${isVisible ? 'scale-100' : 'scale-110'}`}>
        <Loader2 className="w-8 h-8 text-uasYellow animate-spin mr-3" />
        <div>
          <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
            Loading Rebate Dashboard
          </h2>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;